import styled from "styled-components"
import { Form } from "../Form"
import { TextInput } from "../Form/TextInput"
import { Checkbox } from "../Form/Checkbox"
import { Button } from "../Button"
import { device } from "../../utils/breakpoints.js"

export const FormContainer = styled.div`
  background: #ffffff;
  box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  padding: 27px 30px 44px;
  margin: 44px 0;

  @media ${device.desktop} {
    padding: 55px 68px 80px;
    max-width: 760px;
    margin: 64px 0 29px;
  }
`
export const SubmitButton = styled(Button)`
  margin-top: 20px;
  background: transparent;
  border: 2px solid #f17071;
  border-radius: 30px;
  width: 100%;
  text-transform: uppercase;

  @media ${device.desktop} {
    margin-top: 31px;
    height: 60px;
  }

  span {
    font-weight: 600;
    font-size: 14px;
    color: #2a3449;
    letter-spacing: -0.09px;
    text-align: center;
    line-height: 27px;

    @media ${device.desktop} {
      font-size: 16px;
      letter-spacing: -0.1px;
      text-align: center;
      line-height: 27px;
    }
  }

  :hover {
    background: #f17071;
    span {
      color: #fff;
    }
  }
`
export const CustomForm = styled(Form)``

export const FormTitle = styled.h4`
  font-weight: 600;
  color: #2a3449;
  font-size: 20px !important;
  letter-spacing: -0.42px;
  line-height: 24px;
  margin-bottom: 5px !important;

  @media ${device.desktop} {
    font-size: 36px !important;
    letter-spacing: -0.75px;
    line-height: 40px;
    margin-bottom: 15px !important;
  }
`

export const FormText = styled.p`
  font-size: 14px !important;
  color: #5c6370 !important;
  letter-spacing: -0.22px !important;
  line-height: 20px !important;
  margin-bottom: 17px !important;

  @media ${device.desktop} {
    font-size: 18px !important;
    letter-spacing: -0.28px !important;
    line-height: 27px !important;
    margin-bottom: 26px !important;
  }
`

export const FormInputHeader = styled.p`
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #2a3449 !important;
  letter-spacing: -0.25px !important;
  line-height: 24px !important;
  margin-bottom: 0 !important;
  margin-bottom: ${props => props.marginBottom && "10px"} !important;
  margin-top: ${props => props.marginTop && "22px"} !important;

  @media ${device.desktop} {
    font-size: 20px !important;
    letter-spacing: -0.31px !important;
    line-height: 27px !important;
    margin-bottom: ${props => props.marginBottom && "15px"} !important;
    margin-top: ${props => props.marginTop && "164px"} !important;
  }
`

export const FormTextInput = styled(TextInput)`
  background: #eff1f5;
  height: ${props => (props.type === "textarea" ? "95px" : "51px")};
  margin-bottom: 12px;
  box-shadow: none;
  font-weight: 400;

  @media ${device.desktop} {
    height: ${props => (props.type === "textarea" ? "120px" : "62px")};
    margin-top: 3px;
    margin-bottom: 19px;
  }
  input,
  textarea {
    color: #5c6370;
    background: #eff1f5;
  }
`
export const FormCheckbox = styled(Checkbox)`
  font-weight: 500;
  font-size: 14px;
  color: #5c6370;
  letter-spacing: -0.22px;
  line-height: 22px;
  margin-top: 20px;

  input {
    width: 100%;
  }

  @media ${device.desktop} {
    font-size: 16px;
    letter-spacing: -0.25px;
    line-height: 22px;

    margin-top: 40px;
  }

  label {
    padding-left: 9px;
    padding-top: 6px;
    font-weight: 400;
  }

  span {
    height: 32px;
    width: 32px;
  }

  a {
    text-decoration: none;
    font-weight: 600;
    position: relative;
    color: #2a3449;
    background-image: linear-gradient(to right, #f17071, #f17071);
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-size: 100% 2px;
    padding-bottom: 1px;

    :hover {
      background-image: linear-gradient(to right, transparent, transparent);
    }
  }
`

export const SubmittedMessage = styled.h3`
  font-size: 22px;
  line-height: 120%;
  @media ${device.desktop} {
    font-size: 28px;
  }

  br {
    /* display: none; */
    @media ${device.desktop} {
      display: block;
    }
  }
`

